export const RESET_CFOP_PARAMETERIZATION = 'CFOP_PARAMETERIZATIONS/RESET_CFOP_PARAMETERIZATION';
export const SET_SUMMARY_CFOP_PARAMETERIZATIONS =
  'CFOP_PARAMETERIZATIONS/SET_SUMMARY_CFOP_PARAMETERIZATIONS';
export const SET_PAGINATION_CFOP_PARAMETERIZATIONS =
  'CFOP_PARAMETERIZATIONS/SET_PAGINATION_CFOP_PARAMETERIZATIONS';
export const SET_DETAILED_CFOP_PARAMETERIZATION =
  'CFOP_PARAMETERIZATIONS/SET_DETAILED_CFOP_PARAMETERIZATION';
